module.exports = __webpack_public_path__ + "static/media/notification.868c9302.mp3";